import axios, { AxiosError } from 'axios'

import store from '@/store'

axios.defaults.withCredentials = false

const service = axios.create({
  headers: {
    Accept: 'application/json'
  },
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 8000
})

service.interceptors.request.use(config => {
  config.headers.Authorization = `Bearer ${store.state.token}`
  return config
}, error => {
  return Promise.reject(error)
})

service.interceptors.response.use(
  res => res,
  (error: AxiosError) => {
    store.dispatch('loading', false)

    if (!error.response) {
      if (error.message === 'Network Error') {
        store.dispatch('showErrorMessage', 'エラーが発生しました。ネットワーク状態をご確認いただき、再度お試しください。改善しない場合はお手数ですがサポートまでご連絡ください。')
      } else {
        store.dispatch('showErrorMessage', error.message)
      }
      return Promise.reject(error)
    }

    // タイムアウトエラー
    if (error.response.status === 408 || error.code === 'ECONNABORTED') {
      store.dispatch('showErrorMessage', '通信がタイムアウトしました')
      return Promise.reject(error)
    }

    const err = error.response.data as api.ErrorResponse
    switch (error.response.status) {
      case 400: // バリデーションエラー
        store.dispatch('showErrorMessage', err.message)
        break

      case 401: // 認証エラー
        store.dispatch('showErrorMessage', err.message)
        store.dispatch('logout')
        break
    }
    return Promise.reject(error)
  }
)

export default service
